import { memo, useCallback } from "react";
import { IconButton } from "@mui/material";
import BinIcon from "../../../../assets/icons/BinIcon";

export type RemoveCellProps = {
    clientOrderId: string,
    onRemove: (clientOrderId: string) => void
}

const RemoveCell: React.FC<RemoveCellProps> = ({clientOrderId, onRemove}) => {

    const removeOrder = useCallback(() => {
        onRemove(clientOrderId);
    }, [clientOrderId, onRemove])
    return  <IconButton sx={{ padding: 0 }} onClick={removeOrder}><BinIcon fontSize='small' /></IconButton>
}

export default memo(RemoveCell);